'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib = require('tslib');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var core = require('@material-ui/core');
var SmallDarkText = require('../../../typography/SmallDarkText/SmallDarkText.js');
var utils = require('./utils.js');

var Container = styled__default.div(templateObject_1 || (templateObject_1 = tslib.__makeTemplateObject(["\n  background-color: ", ";\n  cursor: pointer;\n  overflow-y: auto;\n  overflow-x: hidden;\n  height: calc(100% - 2px); /* The 2px accounts for the border */\n  flex: 1;\n  border: 1px solid ", ";\n  border-left-width: 3px;\n  border-color: ", ";\n  border-radius: 6px;\n"], ["\n  background-color: ",
    ";\n  cursor: pointer;\n  overflow-y: auto;\n  overflow-x: hidden;\n  height: calc(100% - 2px); /* The 2px accounts for the border */\n  flex: 1;\n  border: 1px solid ", ";\n  border-left-width: 3px;\n  border-color: ",
    ";\n  border-radius: 6px;\n"])), function (_a) {
    var status = _a.status, darkness = _a.darkness;
    return utils.getBackgroundColorFrom(status, darkness);
}, function (_a) {
    var status = _a.status;
    return utils.getColorFrom(status);
}, function (_a) {
    var status = _a.status, darkness = _a.darkness;
    return utils.getBackgroundColorFrom(status, darkness + 10);
});
var AppointmentCard = styled__default.div(templateObject_2 || (templateObject_2 = tslib.__makeTemplateObject(["\n  cursor: pointer;\n  height: 100%;\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 0.3rem;\n  box-sizing: border-box;\n"], ["\n  cursor: pointer;\n  height: 100%;\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 0.3rem;\n  box-sizing: border-box;\n"])));
var TitleP = styled__default(core.Typography)(templateObject_3 || (templateObject_3 = tslib.__makeTemplateObject(["\n  padding: 0px;\n  margin: 0px;\n  font-weight: 700;\n  padding-top: -2px;\n  margin-top: -2px;\n  font-size: 15px;\n  line-height: 18px;\n"], ["\n  padding: 0px;\n  margin: 0px;\n  font-weight: 700;\n  padding-top: -2px;\n  margin-top: -2px;\n  font-size: 15px;\n  line-height: 18px;\n"])));
var NameP = styled__default(SmallDarkText)(templateObject_4 || (templateObject_4 = tslib.__makeTemplateObject(["\n  margin-top: 3px;\n"], ["\n  margin-top: 3px;\n"])));
var getTooltipStyles = function (status, darkness) {
    return {
        arrow: {
            fontSize: 16,
            width: 17,
            color: utils.getBackgroundColorFrom(status, darkness + 10),
            '&::before': {
                border: "1px solid " + utils.getBackgroundColorFrom(status, darkness + 10),
                backgroundColor: utils.getBackgroundColorFrom(status, darkness),
                boxSizing: 'border-box',
                borderRadius: 0,
            },
        },
        tooltip: {
            borderRadius: '6px',
            backgroundColor: utils.getBackgroundColorFrom(status, darkness),
            border: "1px solid " + utils.getColorFrom(status),
            maxWidth: '200px',
            height: '100%',
        },
    };
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

exports.AppointmentCard = AppointmentCard;
exports.Container = Container;
exports.NameP = NameP;
exports.TitleP = TitleP;
exports.getTooltipStyles = getTooltipStyles;
